import React, { useState } from "react";
import Spacing from "../Spacing";

export default function InviteSpecialistModal({
  viewInvitationModal = {},
  setViewInvitationModal = () => {},
  account_id = "",
  location_id = ""
}) {
  const [error, setError] = useState("");
  const [invitedata, setInvitedata] = useState({
    account_id: account_id,
    location_id: location_id,
    multiple_email: [],
  });

  const validateEmails = (emails) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emails.every(email => emailPattern.test(email));
};

  const handleChangeInviteDate = (e) => {
    const { name, value } = e.target;
    const emailArray = value.split(',').map(email => email.trim()).filter(email => email !== "");

    if (validateEmails(emailArray)) {
      setError("");
      setInvitedata({
        ...invitedata,
        [name]: emailArray
      });
    } else {
      setError("Email addresses are invalid.");
    }
  };

  const InviteJoinSubmit = async (e) => {
    e.preventDefault();
    e.target.disabled = true;

    if(!error){
      console.log(invitedata);
      setViewInvitationModal(false);
    }

    e.target.disabled = false;
  };

  return (
    <>
      {viewInvitationModal && (
        <div className="docpro_modal_wrap">
          <div className="docpro_modal_overlay" ></div>
          <div className="docpro_invition_section">
            <div className="docpro_modal">

              <div className="flex">
                <div className="invitation_details">
                  <form onSubmit={InviteJoinSubmit}>
                    <h4>Invite a physician to connect and collaborate on <span className="docpro_accent_color">DocPro</span>.</h4>
                    <p>
                      Strengthen your referral network and enhance patient care by inviting fellow physicians or specialists to join DocPro. Simply enter their Email addresses, and we'll send an invitation to help them discover the benefits of our seamless referral management platform.
                    </p>
                    <textarea
                      required
                      minLength={2}
                      name="multiple_email"
                      className="docpro_fs_14 docpro_form_field size_lg"
                      cols="30"
                      rows="2"
                      placeholder="Enter email addresses separated by commas"
                      onChange={handleChangeInviteDate}
                    ></textarea>
                    {error && <p className="docpro_red_color docpro_mb_0">{error}</p>}

                    <Spacing lg="26" sm="26" />
                    <div className="docpro_modal_btns">
                      <button type="button" className="docpro_bordered_btn docpro_fw_600 size_lg"
                        onClick={() => setViewInvitationModal(!viewInvitationModal)}
                      >
                        Cancel
                      </button>
                      <button type='submit' className="docpro_bordered_btn size_lg docpro_fw_600 docpro_white_color docpro_filed_btn">
                        <span>Send</span>
                      </button>
                    </div>
                  </form>
                </div>

                <div className="invitation_image">
                  <img className="image-cover" src={`/images/invite-user.jpg`} alt="Invitation" />
                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </>
  );
}
